import React, { useState } from 'react';
import { setCrmLeadArchived } from '../config/api';

const CrmArchiveLeadDialog = ({ lead, restore = false, onClose, onSaved, onArchived }) => {
  const [confirmed, setConfirmed] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const save = async () => {
    if (!confirmed || saving) return;
    setSaving(true);
    setError('');
    try {
      await setCrmLeadArchived(lead.id, !restore);
      if (onSaved) onSaved();
      if (onArchived) onArchived();
    } catch (err) {
      setError(err.message || `Could not ${restore ? 'restore' : 'archive'} the Lead.`);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={saving ? undefined : onClose}>
      <div className="modal-content" onClick={(event) => event.stopPropagation()} style={{ maxWidth: '500px' }}>
        <div className="modal-header">
          <div>
            <h3>{restore ? 'Unarchive Lead' : 'Archive Lead'}</h3>
            <div className="crm-modal-subtitle">
              {restore ? 'Return this Lead to active CRM lists.' : 'Remove this Lead from active CRM lists.'}
            </div>
          </div>
          <button type="button" className="modal-close" onClick={onClose} disabled={saving}>×</button>
        </div>
        <div className="modal-body">
          <div className="crm-archive-lead-summary">
            <strong>{lead.displayName || `Lead #${lead.id}`}</strong>
            <span>L-{String(lead.id).padStart(5, '0')}</span>
          </div>
          <p className="crm-muted">{restore
            ? 'The Lead and all retained CRM data will become active again.'
            : 'Contacts, linked identifiers, communication history and audit records will be retained.'}</p>
          <label className="crm-archive-confirmation">
            <input
              type="checkbox"
              checked={confirmed}
              onChange={(event) => {
                setConfirmed(event.target.checked);
                setError('');
              }}
              disabled={saving}
            />
            I confirm this Lead should be {restore ? 'unarchived' : 'archived'}.
          </label>
          {error && <div className="crm-form-error">{error}</div>}
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-secondary" onClick={onClose} disabled={saving}>Cancel</button>
          <button type="button" className={restore ? 'btn btn-primary' : 'btn btn-danger'} onClick={save} disabled={saving || !confirmed}>
            {saving ? (restore ? 'Restoring…' : 'Archiving…') : (restore ? 'Unarchive Lead' : 'Archive Lead')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CrmArchiveLeadDialog;
